import Vue from 'vue'
import Router from 'vue-router'
import ProductListView from '@/views/ProductListView';
import ProductDetailView from '@/views/ProductDetailView';
import Express from "../components/Express";
import Agent from "../components/Agent";
import Furniture from "../components/Furniture";
import Commercial from "../components/Commercial";
import Art from "../components/Art";
import Move from "../components/Move";
import MoveItem from "../components/MoveItem";
import VModal from 'vue-js-modal'
import AboutUs from "../components/AboutUs";
Vue.use(Router);
Vue.use(VModal, { dialog: true, width:'90%' })
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/about-us',
      component: AboutUs,
    },
    {
      path: '/',
      component: Move,
    },
    {
      path: '/moveItem',
      component: MoveItem,
    },
    {
      path: '/express',
      component: Express,
    },
    {
      path: '/agent',
      component: Agent,
    },
    {
      path: '/furniture',
      component: Furniture,
    },
    {
      path: '/commercial',
      component: Commercial,
    },
    {
      path: '/art',
      component: Art,
    },
    {
      path: '/category/:categoryId',
      component: ProductListView,
      props: function(route) {
        return {
          categoryId: Number(route.params.categoryId),
        }
      },
    },
    {
      path: '/product/:productId',
      component: ProductDetailView,
      props: function(route) {
        return {
          productId: Number(route.params.productId),
        }
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js